import React from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../../hooks/useLanguage';

export const DemoLimitationsModal = ({ isOpen, onClose }) => {
  const [isSpanish] = useLanguage();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] animate-fadeIn">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4 animate-modalEnter max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-2xl font-bold">
            {isSpanish ? 'Limitaciones de la Demo' : 'Demo Limitations'}
          </h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-6 h-6 text-gray-600" />
          </button>
        </div>

        <div className="mt-8">
          <ul className="space-y-3 text-sm text-gray-800 list-disc list-inside">
            <li>{isSpanish ? 'Máximo 5 solicitudes de demostración' : 'Maximum 5 demo requests'}</li>
            <li>{isSpanish ? 'Máximo 20 archivos PDF por solicitud, 20MB cada uno' : 'Maximum 20 PDF files per request, 20MB each'}</li>
            <li>{isSpanish ? 'Los resultados no se guardan y no se pueden recuperar más tarde' : 'Results are not saved and cannot be retrieved later'}</li>
            <li>{isSpanish ? 'Sin gestión de cuenta ni almacenamiento de datos' : 'No account management or data storage'}</li>
            <li>{isSpanish ? 'Soporte limitado en comparación con las cuentas completas' : 'Limited support compared to full accounts'}</li>
          </ul>
         <div>
         <p className="mt-8 mb-0 text-sm text-gray-800">
            {isSpanish 
              ? 'Para acceso ilimitado y funciones completas,'
              : 'For unlimited access and full features,'}
          </p>
          <p className="text-sm text-gray-800">
            {isSpanish 
              ? 'por favor contacte con '
              : 'please contact '}
              <a href="www.atlantisdigital.nl" target="_blank" className="text-default font-bold hover:underline">Atlantis Digital</a>
              .
          </p>
         </div>
        </div>
      </div>
    </div>
  );
};

export default DemoLimitationsModal;

